/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useLayoutEffect, useEffect, useState } from "react";
import objectPath from "object-path";
import { useLocation } from "react-router-dom";
import { QuickActions } from "./components/QuickActions";
import { BreadCrumbs } from "./components/BreadCrumbs";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Dropdown } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // Main CSS file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
import { enUS } from "date-fns/locale"; // Import English locale for date-fns
import { Button } from "react-bootstrap";
import moment from "moment";
import { defaultDate } from "../../../../app/utility";
import {
  fetchDashboard,
  fetchVisibility,
  resetData,
  selectLoading,
} from "../../../../app/pages/company/companySlice";
import { useDispatch, useSelector } from "react-redux";
import { LayoutSplashScreen } from "../../_core/MetronicSplashScreen";
import { InputDateRange } from "../../../../app/utility/InputDateRange";
export function SubHeader() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {
    dispatch(resetData());

    setStartDate(defaultDate);
    setEndDate(defaultDate);
  }, [subheader]);

  const [startDate, setStartDate] = useState(defaultDate);
  const [endDate, setEndDate] = useState(defaultDate);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div
        id="kt_subheader"
        className={`subheader py-2 py-lg-4   ${layoutProps.subheaderCssClasses}`}
      >
        <div
          className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
        >
          {/* Info */}
          <div className="d-flex align-items-center flex-wrap mr-1">
            {layoutProps.subheaderMobileToggle && (
              <button
                className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                id="kt_subheader_mobile_toggle"
              >
                <span />
              </button>
            )}

            <div className="d-flex align-items-baseline mr-5">
              <h5 className="text-dark font-weight-bold my-2 mr-5">
                <>{subheader.title}</>
                {/*<small></small>*/}
              </h5>
            </div>

            <BreadCrumbs items={subheader.breadcrumbs} />
          </div>
          {location.pathname === "/dashboard" && (
            <>
              <div className="d-flex align-items-center">
                {defaultDate === startDate && (
                  <b className="text-dark font-weight-bold  mr-5">Today</b>
                )}
                <InputDateRange
                  setEndDate={setStartDate}
                  setStartDate={setEndDate}
                  endDate={startDate}
                  startDate={endDate}
                  CallApi={fetchDashboard}
                  paramsFilter={{}}
                  paramsStart={"start_date"}
                  paramsEnd={"end_date"}
                  hidden={true}
                />
              </div>
            </>
          )}
          {location.pathname === "/dashboard/visibility" && (
            <>
              <div className="d-flex align-items-center">
                {defaultDate === startDate && (
                  <b className="text-dark font-weight-bold  mr-5">Today</b>
                )}
                <InputDateRange
                  setEndDate={setStartDate}
                  setStartDate={setEndDate}
                  endDate={startDate}
                  startDate={endDate}
                  CallApi={fetchVisibility}
                  paramsFilter={{
                    type: "per_sales",
                    user_id: "abc0213e-bba5-4221-8d23-004124430169",
                  }}
                  paramsStart={"start_date"}
                  paramsEnd={"end_date"}
                  hidden={true}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
